import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

import {
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faMap,
} from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  return (
    <footer className="custom-footer">

      <div className="footer-container">

        {/* LEFT - LOGO */}
        <div className="footer-section footer-logo-section">
          <img
            src="/images/sailogo.png"
            alt="Sri Gnana Sai Baba Mandir Logo"
            className="profile-img"
          />

          <h3 className="column-title">Sri Gnana Sai Baba Mandir</h3>

          <p className="address-text">
            Visit us for daily poojas, <br />
            spiritual guidance, and divine blessings of Lord Sai Baba.
          </p>
        </div>

        {/* CENTER - CONTACT + ADDRESS */}
        <div className="footer-section contact-address-grid">

          {/* CONTACT */}
          <div className="contact-column">
            <h3 className="column-title">GOT QUESTIONS? CALL US</h3>

            <div className="info-row">
              <FontAwesomeIcon icon={faPhone} />
              <a href="tel:+919841245070" className="info-link">
                +91 98412 45070
              </a>
            </div>

            <div className="info-row">
              <FontAwesomeIcon icon={faPhone} />
              <a href="tel:+916381720140" className="info-link">
                +91 63817 20140
              </a>
            </div>

            <div className="info-row">
              <FontAwesomeIcon icon={faPhone} />
              <a href="tel:+919941425158" className="info-link">
                +91 99414 25158
              </a>
            </div>

            <div className="info-row">
              <FontAwesomeIcon icon={faEnvelope} />
              <a href="mailto:gurujiambattur@gmail.com" className="info-link">
                gurujiambattur@gmail.com
              </a>
            </div>

            <div className="info-row">
              <FontAwesomeIcon icon={faEnvelope} />
              <a href="mailto:vishya9790@gmail.com" className="info-link">
                vishya9790@gmail.com
              </a>
            </div>
          </div>

          {/* DIVIDER */}
          <div className="footer-divider"></div>

          {/* ADDRESS */}
          <div className="address-column">
            <h3 className="column-title">ADDRESS</h3>

            <div className="info-row">
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              <span className="address-text">
                Ragavendra St, Venkateswara Nagar Extension,
                Ambattur, Chennai, Tamil Nadu 600062
              </span>
            </div>

            <div className="info-row">
              <FontAwesomeIcon icon={faMap} />
              <a
                href="https://www.google.com/maps/dir//Sri+Gnana+Sai+Baba+Temple,+Ragavendra+St,+Venkateswara+Nagar+Extension,+Ambattur,+Chennai,+Tamil+Nadu+600062"
                target="_blank"
                rel="noopener noreferrer"
                className="info-link"
              >
                View on Google Maps
              </a>
            </div>
          </div>

        </div>

        {/* SACRED SEVAS - HOMAM REGISTRATION (3 LINKS) */}
        <div className="footer-section footer-homam-cta-col">
          <h3 className="column-title">SACRED SEVAS</h3>
          <p className="address-text" style={{ marginBottom: 12 }}>
            Participate in divine Vedic yagnas & seek Baba's grace:
          </p>

          <div className="footer-homam-links-group" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {/* Link 1: Standard Homam Registration */}
            <Link
              to="/homam-registration"
              className="footer-homam-card-link"
              id="footer-homam-registration-link"
              title="Standard 27 Nakshatra Homam Registration"
            >
              <div className="footer-homam-tag">
                <span className="footer-homam-pulse-dot"></span>
                <span>ONLINE REGISTRATION</span>
              </div>
              <div className="footer-homam-headline">
                27 Nakshatra Maha Homam
              </div>
              <div className="footer-homam-subtext">
                Book your birth star & seva online →
              </div>
            </Link>

            {/* Link 2: Split Video & Form Registration */}
            <Link
              to="/homam-registration-split"
              className="footer-homam-card-link footer-homam-card-split"
              id="footer-homam-registration-split-link"
              title="Split View Homam Registration (Video & Form Side-by-Side)"
            >
              <div className="footer-homam-tag footer-homam-tag-purple">
                <span className="footer-homam-pulse-dot bg-purple"></span>
                <span>HERO SPLIT VIDEO & FORM</span>
              </div>
              <div className="footer-homam-headline">
                Homam Booking (Split View)
              </div>
              <div className="footer-homam-subtext">
                Watch video & register side-by-side →
              </div>
            </Link>

            {/* Link 3: Direct Form & Video Below Registration */}
            <Link
              to="/homam-registration-direct"
              className="footer-homam-card-link footer-homam-card-direct"
              id="footer-homam-registration-direct-link"
              title="Direct Form Registration with Video Below"
            >
              <div className="footer-homam-tag footer-homam-tag-amber">
                <span className="footer-homam-pulse-dot bg-amber"></span>
                <span>DIRECT FORM & VIDEO BELOW</span>
              </div>
              <div className="footer-homam-headline">
                Homam Booking (Direct Form)
              </div>
              <div className="footer-homam-subtext">
                Fast booking form & video player →
              </div>
            </Link>
          </div>
        </div>

        {/* RIGHT - SOCIAL */}
        <div className="footer-section">

          <h3 className="column-title">FOLLOW US</h3>

          <div className="footer-social-row">

            <a
              href="https://www.facebook.com/share/1HC1MpStwK/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon fb"
              aria-label="Facebook"
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>

            <a
              href="https://www.instagram.com/srignanasaibabamandir"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon ig"
              aria-label="Instagram"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>

            <a
              href="https://youtube.com/@srignanasaibabamandir"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon yt"
              aria-label="YouTube"
            >
              <FontAwesomeIcon icon={faYoutube} />
            </a>

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;